import { TUrlPath } from "../../types/elements/XText.types";

export const URL_PATHS: TUrlPath[] = [
  "/",
  "/shop",
  // "/categories/[slug]",
  "/about-us",
  "/contact-us",
  // "/blog",
  // "/blog/[slug]",
  // "/checkout",
  "/products/[slug]",
];

export const EDITABLE_PATHS: TUrlPath[] = [
  "/",
  "/shop",
  "/products/[slug]",
  "/about-us",
  "/contact-us",
];
